import { FaMoneyBill } from "react-icons/fa";
import { months, years } from "../utils/rawData/dateValues";
import { formatDate } from "../utils/rawData/dateValues";
import { useEffect, useState } from "react";
import axios from "axios";
import { BACKEND } from "../config/configEnvs";
import LoadingScreen from "../components/ui/temp-screens/LoadingScreen";
import NoDataScreen from "../components/ui/temp-screens/NoDataScreen";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import multiMonthPlugin from "@fullcalendar/multimonth";
import listPlugin from "@fullcalendar/list";
import Tippy from 'tippy.js';
import { toast } from "react-toastify";


const GastosAgencia = () => {

  const [month, setMonth] = useState(new Date().getMonth() + 1);
  const [year, setYear] = useState(new Date().getFullYear());

  const [loading, setLoading] = useState(false);
  const [view, setView] = useState("calendar");

  const [paymentsWorkers, setPaymentsWorkers] = useState([]);
  const [incidences, setIncidences] = useState([]);
  const [purchases, setPurchases] = useState([]);

  const amountPaymentWorkers = paymentsWorkers.reduce((acc, p) => acc + (p.amount || 0), 0);
  const amountIncidences = incidences.reduce((acc, i) => acc + (i.descuento || 0), 0);
  const purchasesSoles = purchases.filter(p => p.moneda === "soles").reduce((acc, p) => acc + (p.importe_total || 0), 0);

  const totalSpends = amountPaymentWorkers + purchasesSoles - amountIncidences;

  const purchasesDolares = purchases.filter(p => p.moneda === "dolares").reduce((acc, p) => acc + (p.importe_total || 0), 0);

  const colorPaymentStatus = {
    "Pendiente": "#FCA5A5",  // bg-red-300
    "Adelanto": "#86EFAC",   // bg-green-300
    "Pagado": "#93C5FD",     // bg-blue-300
  }

  const colorPurchaseStatus = {
    "Pendiente": "#FACC15",  // bg-yellow-500
    "Pagado": "#86EFAC",     // bg-green-500
  }

  const totalEvents = [
    ...paymentsWorkers.map((p) => ({
      id: `${p.id}`,
      title: `Pago trabajador: ${p.worker?.name}`,
      start: new Date(new Date(p.datePayment).getTime() + (5 * 60 * 60 * 1000)).toISOString(),
      allDay: true,
      color: colorPaymentStatus[p.status],
      textColor: "#000000",
      className: "text-xs",
      order: 2,
      extendedProps: {
        tippyText: `Pago trabajador: ${p.worker?.name} - S/. ${p.amount} - ${p.status}`,
        concept: `Pago trabajador: ${p.worker?.name}`,
        amount: p.amount?.toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }),
        currency: "PEN",
        status: p.status,
        color: colorPaymentStatus[p.status],
        type: "payment"
      }
    })),
    ...purchases.map((p) => ({
      id: `${p.id}`,
      title: `Compra: ${p.nombre_item} - ${p.moneda === "soles" ? "S/." : "$"} ${p.importe_total}`,
      start: new Date(new Date(p.fecha_pago).getTime() + (5 * 60 * 60 * 1000)).toISOString(),
      allDay: true,
      color: colorPurchaseStatus[p.estadoPago],
      textColor: "#000000",
      className: "text-xs",
      order: 2,
      extendedProps: {
        tippyText: `Compra: ${p.nombre_item} - ${p.moneda === "soles" ? "S/." : "$"} ${p.importe_total} - ${p.estadoPago}`,
        concept: `Compra: ${p.nombre_item}`,
        amount: p.importe_total.toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }),
        currency: p.moneda === "soles" ? "PEN" : "USD",
        status: p.estadoPago,
        color: colorPurchaseStatus[p.estadoPago],
        type: "purchase"
      }
    })),
  ];
  
  // Calcular totales por día
  const dailyTotals = {};
  
  // Sumar pagos a trabajadores
  paymentsWorkers.forEach(p => {
    const date = new Date(p.datePayment).toISOString().split('T')[0];
    if (!dailyTotals[date]) {
      dailyTotals[date] = { soles: 0, dolares: 0 };
    }
    dailyTotals[date].soles += p.amount;
  });

  // Sumar compras
  purchases.forEach(p => {
    const date = new Date(p.fecha_pago).toISOString().split('T')[0];
    if (!dailyTotals[date]) {
      dailyTotals[date] = { soles: 0, dolares: 0 };
    }
    if (p.moneda === "soles") {
      dailyTotals[date].soles += p.importe_total;
    } else {
      dailyTotals[date].dolares += p.importe_total;
    }
  });

  // Crear eventos de totales
  const totalEventsWithDailyTotals = [
    ...totalEvents,
    ...Object.entries(dailyTotals).map(([date, totals]) => ({
      id: `total-${date}`,
      title: `Total del día: S/. ${totals.soles.toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })} - $ ${totals.dolares.toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })}`,
      start: new Date(new Date(date).getTime() + (5 * 60 * 60 * 1000)).toISOString(),
      allDay: true,
      color: "#6B7280", // bg-gray-500
      textColor: "#FFFFFF",
      className: "text-xs font-bold",
      order: 1,
      extendedProps: {
        tippyText: `Total del día: S/. ${totals.soles.toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        })} - $ ${totals.dolares.toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        })}`,
        concept: "Total del día",
        amount: `${totals.soles.toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        })} - $ ${totals.dolares.toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        })}`,
        currency: "MIXED",
        status: "Total",
        color: "#6B7280"
      }
    }))
  ];

  const getData = async () => {
    try {
      setLoading(true);
      const responsePayments = await axios.get(`${BACKEND}/api/pagosTrabajadores?limit=0&where[month][equals]=${month}&where[year][equals]=${year}`);
      const responseIncidences = await axios.get(`${BACKEND}/api/incidencias?limit=0&where[month][equals]=${month}&where[year][equals]=${year}`);
      const responsePurchases = await axios.get(`${BACKEND}/api/compras?limit=0&where[month][equals]=${month}&where[year][equals]=${year}`);

      setPaymentsWorkers(responsePayments.data.docs)
      setIncidences(responseIncidences.data.docs);
      setPurchases(responsePurchases.data.docs);

    } catch (error) {
      toast.error("Error al obtener los datos");
    } finally {
      setLoading(false);
    }
  }
  
  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    getData();
  }, [month, year]);

  return (
    <div className="flex flex-col h-screen w-full">

      {/* Header */}
      <div className="flex flex-row px-4 py-2 bg-gray-100">
        <div className="flex flex-row w-full items-center gap-4 justify-between overflow-x-auto">

          <div className="flex items-center gap-4 p-4">
            <FaMoneyBill className="text-2xl text-gray-700" />
            <h2 className="text-2xl font-bold text-gray-700">Gastos de la agencia</h2>
          </div>

          <div className="flex flex-row gap-4 items-center justify-center">

            <div className="flex flex-row text-xs text-gray-700 items-center justify-center gap-4">
              <span>Vista:</span>
              <select
                value={view}
                onChange={(e) => setView(e.target.value)}
                className="text-gray-700 hover:cursor-pointer text-xs bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px] pr-10"
              >
                <option value="table">Tabla</option>
                <option value="calendar">Calendario</option>
              </select>
            </div>

            <div className="flex flex-row text-xs text-gray-700 items-center justify-center gap-4">
              <span>Mes:</span>
              <select
                value={month}
                onChange={(e) => setMonth(e.target.value)}
                className="text-gray-700 hover:cursor-pointer text-xs bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px] pr-10"
              >
                {months.map((month) => (
                  <option key={month.value} value={month.value}>{month.label}</option>
                ))}
              </select>
            </div>

            <div className="flex flex-row text-xs text-gray-700 items-center justify-center gap-4">
              <span>Año:</span>
              <select
                value={year}
                onChange={(e) => setYear(e.target.value)}
                className="text-gray-700 hover:cursor-pointer text-xs bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px] pr-10"
              >
                {years.map((year) => (
                  <option key={year.value} value={year.value}>{year.label}</option>
                ))}
              </select>
            </div>
          </div>
        </div>
      </div>

      {/* Resumen */}
      <div className="flex bg-gray-100 mt-0.5 mb-0.5 w-full">
        <div className="w-full items-center justify-center overflow-x-auto py-1 [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
          <div className="flex flex-row gap-8 min-w-max px-4 items-center justify-center">   
            
            {loading ? (
              <LoadingScreen />
            ) : (
              <>  
                {/* Cantidad trabajadores */}
                <div className="flex flex-row gap-2 items-center justify-center">
                  <span className="block text-xs truncate font-medium text-gray-900">
                    Trabajadores:
                  </span>
                  <span className="block text-xs truncate text-gray-900">
                    {paymentsWorkers.length}
                  </span>
                </div>     

                {/* Planilla */}
                <div className="flex flex-row gap-2 items-center justify-center">
                  <span className="block text-xs truncate font-medium text-gray-900">
                    Sueldos (Sin desc.):
                  </span>
                  <span className="block text-xs truncate text-green-500">
                    S/. {(amountPaymentWorkers).toLocaleString("en-US", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2            
                    })}
                  </span>
                </div>

                {/* Cantidad incidencias */}
                <div className="flex flex-row gap-2 items-center justify-center">
                  <span className="block text-xs truncate font-medium text-gray-900">
                    Incidencias:
                  </span>
                  <span className="block text-xs text-red-500 truncate text-gray-900">
                    {incidences.length}
                  </span>
                </div>

                {/* Descuentos incidencias */}
                <div className="flex flex-row gap-2 items-center justify-center">
                  <span className="block text-xs truncate font-medium text-gray-900">
                    Descuentos incidencias:
                  </span>
                  <span className="block text-xs truncate text-red-500">
                    S/. {amountIncidences.toLocaleString("en-US", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2            
                    })}
                  </span>
                </div>

                {/* Compras */}
                <div className="flex flex-row gap-2 items-center justify-center">
                  <span className="block text-xs truncate font-medium text-gray-900">
                    Compras:
                  </span>
                  <span className="block text-xs truncate text-gray-900">
                    {purchases.length}
                  </span>
                </div>

                {/* Total compras */}
                <div className="flex flex-row gap-2 items-center justify-center">
                  <span className="block text-xs truncate font-medium text-gray-900">
                    Total compras:
                  </span>
                  <span className="block text-xs truncate text-gray-900">
                    S/. {purchasesSoles.toLocaleString("en-US", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2            
                    })} - $ {purchasesDolares.toLocaleString("en-US", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2            
                    })}
                  </span>
                </div>

                {/* Gastos totales */}
                <div className="flex flex-row gap-2 items-center justify-center">
                  <span className="block text-xs truncate font-medium text-gray-900">
                    Gastos totales:
                  </span>
                  <span className="block text-xs truncate font-medium text-gray-900">
                    <span className="text-blue-500">S/. {totalSpends.toLocaleString("en-US", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2            
                    })}</span> - 
                    <span className="text-blue-500"> $ {purchasesDolares.toLocaleString("en-US", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2            
                    })}</span>
                  </span>
                </div>
              </>
            )}
          </div>
        </div>
      </div>

      {/* Tabla de gastos */}
      <div className="flex-grow overflow-y-auto">
        {loading ? (
          <LoadingScreen />
        ) : (
          totalEventsWithDailyTotals.length === 0 ? (
            <NoDataScreen />
          ) : (
            view === "table" ? (
              <table className="w-full text-xs">
                <thead className="bg-white sticky top-0">
                  <tr className="text-gray-700 text-center text-[10px] font-bold">
                    <th className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                      Fecha
                    </th>
                    <th className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                      Concepto
                    </th>
                    <th className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                      Monto
                    </th>
                    <th className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                      Moneda
                    </th>
                    <th className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                      Estado
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {totalEvents.sort((a, b) => new Date(a.start) - new Date(b.start)).map((e) => (
                    <tr key={e.id} className={`text-xs py-3 w-full hover:bg-gray-100 transition-all duration-100 ${e.extendedProps.type === "payment" ? "bg-blue-50" : "bg-green-50"}`}>

                      <td scope="row" className="px-4 py-3 text-center whitespace-nowrap border border-gray-30">
                        <span className="flex items-center justify-center">
                          {formatDate(e.start?.split("T")[0])}
                        </span>
                      </td>

                      <td scope="row" className="px-4 py-3 text-center whitespace-nowrap border border-gray-300">
                        <span className="flex items-center justify-center">
                          {e.extendedProps.concept}
                        </span>
                      </td>

                      <td scope="row" className="px-4 py-3 text-center whitespace-nowrap border border-gray-300">
                        <span className="flex items-center justify-center">
                          {e.extendedProps?.amount?.toLocaleString("en-US", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                          })}
                        </span>
                      </td>

                      <td scope="row" className="px-4 py-3 text-center whitespace-nowrap border border-gray-300">
                        <span className="flex items-center justify-center">
                          {e.extendedProps?.currency}
                        </span>
                      </td>

                      <td scope="row" className={`px-4 py-3 text-center whitespace-nowrap border font-bold border-gray-300 ${e.extendedProps.status === "Pendiente" ? "bg-red-100 text-red-500" : "bg-green-100 text-green-500"}`}>
                        <span className="flex items-center justify-center">
                          {e.extendedProps?.status}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <FullCalendar
                events={totalEventsWithDailyTotals}
                eventOrder={"order,start,-duration,title"}
                className="w-full h-full my-4"
                datesSet={(e) => {
                  const viewStartDate = e.view.currentStart;
                  setMonth(viewStartDate.getMonth() + 1);
                  setYear(viewStartDate.getFullYear());
                }}
                plugins={[
                  dayGridPlugin,
                  timeGridPlugin,
                  interactionPlugin,
                  listPlugin,
                  multiMonthPlugin,
                ]}
                moreLinkText={"Ver todos"}
                locale={"es"}
                headerToolbar={false}
                initialView={"dayGridMonth"}
                defaultAllDay={true}
                dayMaxEvents={25}
                initialDate={new Date(year, month - 1, 1)}
                validRange={{
                  start: new Date(year, month - 1, 1),
                  end: new Date(year, month, 1)
                }}
                eventContent={function (arg) {

                  let containerEl = document.createElement("div");
                  containerEl.classList = `event-container cursor-pointer transition-all duration-100 hover:bg-gray-100`;
    
                  let contentEl = document.createElement("p");
                  contentEl.classList = "event-content overflow-hidden";
                  contentEl.innerHTML = `${arg.event.title}`;
    
                  containerEl.appendChild(contentEl);
    
                  return { domNodes: [containerEl] };
                }}
                eventDidMount={(info) => {
                  Tippy(info.el, {
                    content: info.event?.extendedProps?.tippyText,
                    placement: 'top',
                    theme: 'dark',
                    animation: 'scale'
                  });
                }}
              />

            )
          )
        )}
      </div>
    </div>
  )
}

export default GastosAgencia;
